<template>
  <div class="write-msg" data-title="申请流程">
    <applyPartner>
      <template v-slot:top>
        <p class="title">
          申请合伙人
        </p>
      </template>
      <template v-slot:left>
        <dl class="contract">
          <dt>
            <img src="../../assets/images/partner-img/1.png" alt="">
          </dt>
          <dd>
            签约合同
          </dd>
        </dl>
      </template>
      <template v-slot:right>
        <dl class="prove">
          <dt>
            <img src="../../assets/images/partner-img/2.png" alt="">
          </dt>
          <dd>
            完成认证
          </dd>
        </dl>
      </template>
    </applyPartner>
    <!-- 姓名 -->
    <section>
      <div class="partner-information">
        <div class="name">
          <p class="title">
            姓名
          </p>
          <van-field v-model="name" placeholder="请输入真实姓名" />
        </div>
        <div class="name">
          <p class="title">
            手机号
          </p>
          <van-field v-model="phone" type="tel" placeholder="请输入真实姓名" />
        </div>
        <div class="name">
          <p class="title">
            身份证号码
          </p>
          <van-field v-model="idcard" placeholder="请输入正确的身份证号码" />
        </div>
        <!-- 城市 -->
        <div class="address" @click="showAddress = true">
          <p class="title">请选择城市区域</p>
          <p class="address-content">
            {{address_value}}
          </p>
        </div>
        <!-- 下一步按钮 -->
        <div class="next-btn" @click="next_btn">

        </div>
        <contactWay></contactWay>
      </div>
    </section>

    <van-popup v-model="showAddress" position="bottom" :style="{ height: '40%' }">
      <van-area 
        title="标题" 
        :area-list="addressList"
        @confirm="sure"
        @cancel="exit"
        />
    </van-popup>
  </div>
  
</template>

<script>

import contactWay from '../../components/partner/contact-way'
import applyPartner from '../../components/partner/apply-partner'
import addressList from '../../../public/addressList/area.js'

import Vue from 'vue';
import { Field, Area, Popup, Toast } from 'vant';

Vue.use(Popup);
Vue.use(Area);
Vue.use(Field);
Vue.use(Toast);

export default {
  data(){
    return{
      name: '',
      phone : '',
      idcard : '',
      addressList : addressList,
      showAddress : false,
      address_value: '',
      partner_msg: [], // 已提交信息未申请
      code: '',
      uid:''
    }
  },
  components:{
    applyPartner,
    contactWay
  },
  created(){
    this.uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+'/api/order/index/getpartner',{
      uid : this.uid
    }).then((res) =>{
      // console.log(res)
      this.code = res.data.code
      if(res.data.data){
        this.partner_msg = res.data.data
        this.name = res.data.data.name
        this.phone = res.data.data.account
        this.idcard = res.data.data.card
        this.address_value = res.data.data.region
      }
    })
  },
  methods:{
    sure(val){
      this.showAddress = false
      // console.log(val)
      this.address_value = `${val[0].name}/${val[1].name}/${val[2].name}`
      // console.log(this.userlist)
      // console.log(this.address_value)
    },
    exit(){
      this.showAddress = false
    },
    // 下一步
    next_btn(){
      // 用户已经填写过信息
      if(this.partner_msg.length != 0){
        if(!this.name){
          Toast('请输入姓名')
        }else if(!this.phone){
          Toast('请输入手机号')
        }else if(!this.idcard){
          Toast('请输入身份证号')
        }else if(!this.address_value){
          Toast('请选择城市区域')
        }else{
          // 合伙人信息添加
          this.$axios.post(this.domain.url+"/api/order/index/update_partner",{
            id : this.partner_msg.id,
            uid : this.uid,
            account : this.phone,
            name: this.name,
            search_time : this.search_time,
            card: this.idcard,
            region: this.address_value
          }).then((res) => {
            // console.log(res)
            if(res.data.code == 1){
              this.$router.replace({
                path:'/sign-contract',
                query:{
                  id : this.partner_msg.id
                }
              })
            }else{
              Toast(res.data.msg)
            }
          })
        }// 用户没有填写过信息
      }else if(this.partner_msg.length == 0){
        if(!this.name){
          Toast('请输入姓名')
        }else if(!this.phone){
          Toast('请输入手机号')
        }else if(!this.idcard){
          Toast('请输入身份证号')
        }else if(!this.address_value){
          Toast('请选择城市区域')
        }else{
          // 合伙人信息添加
          this.$axios.post(this.domain.url+"/api/order/index/addpartner",{
            uid : this.uid,
            account : this.phone,
            name: this.name,
            search_time : this.search_time,
            card: this.idcard,
            region: this.address_value
          }).then((res) => {
            // console.log(res)
            if(res.data.code == 1){
              this.$router.replace({
                path:'/sign-contract',
                query:{
                  id : this.partner_msg.id
                }
              })
            }else{
              Toast(res.data.msg)
            }
          })
        }
      }else{
        Toast(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .write-msg{
    width: 7.5rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-image: url('../../assets/images/partner-img/bag@2x.png');
    background-size: 100% 100%;
    // padding: 0 .3rem 0 .3rem;
    // 信息
    section{
      .partner-information{
        width: 7.1rem;
        height: 8.74rem;
        background: #ffffff;
        margin: 0 auto;
        margin-top: .1rem;
        border-radius: .1rem;
        .name{
          overflow: hidden;
          .title{
            font-size: 0.26rem;
            font-family: PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: .26rem;
            margin-top: .39rem;
            margin-left: .4rem;
          }
        
        }
        // 位置
        .address{
          display: flex;
          align-items: center;
          margin-top: .5rem;
          .title{
            font-size: 0.26rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FF491F;
            margin-left: .3rem;
          }
          .address-content{
            font-size: 0.26rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #212121;
            margin-left: .65rem;
            font-weight: bold;
          }
        }
        // 下一步按钮
        .next-btn{
          width: 2.42rem;
          height: .72rem;
          background-image: url('../../assets/images/partner-img/btn.png');
          background-size: 2.42rem .72rem;
          margin: 0 auto;
          margin-top: 1.06rem;
        }
        .tel{
          font-size: 0.2rem;
          font-family: PingFang SC;
          font-weight: 300;
          color: #A7A7A7;
          text-align: center;
          margin: .91rem 0 .4rem 0;
        }
      }
    }
  }
</style>

